import { Outlet } from 'react-router';
import { Box } from '@mui/material';

const BaseLayout = () => (
  <Box
    sx={{
      flex: 1,
      height: '100%',
    }}
  >
    <Outlet />
  </Box>
);

export default BaseLayout;
